import Group from "../../../utils/services/project/metering/groupService";
import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(Group);
let roles = rolesTemplate(Group);
function prepareItem(i) {
  i._parent = i._parent || { id: null };
  i._ancestors = i._ancestors || [];
  i.is_visible = i.is_visible ? i18n.t("groups.yes") : i18n.t("groups.no");
  return i;
}
const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  },
  getGroupsFromItem(state) {
    let item = crud.getters.getItem(state);
    return (item && item._children && item._children.map(prepareItem)) || [];
  },
  getMetersFromItem(state) {
    let item = crud.getters.getItem(state);
    return (item && item._meters) || [];
  }
};

const actions = {
  ...crud.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    if (item.parent_id) {
      item._parent = { id: item.parent_id };
    }
    return crud.actions.create(null, { item, errorHandler, onSuccess });
  },
  ...roles.actions
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
